// Added to entities that should be hidden on all VPC images
class HideFromVpcImagesComponent {
    constructor() {
        this.typeId = HideFromVpcImagesComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return false;
    }
}
HideFromVpcImagesComponent.id = 2063;
export default HideFromVpcImagesComponent;
//# sourceMappingURL=HideFromVpcImagesComponent.js.map